import * as myxhr from "./myxhr.js";

export function post() {
    return myxhr.post('/newuser');
}